<template>
    <pop-up
        v-bind="{ show, name, placement, slide, separation, fixed, tag }"
        :key="`${name}-${uniqueId}`"
        class="px-4 py-2 text-light font--12 lh--16"
        mode="tooltip"
        style="max-width: 436px"
        :arrow="false"
        @hide="show = false"
    >
        <slot />
    </pop-up>
</template>

<script>
import PopUp from "./PopUp"
import { useListenerManager } from "front-toolkit/plugins/ListenersPlugin"

import { findDomReference } from "~/lib/vueUtils"
import { inside } from "~/lib/utils"

const DELAY = 500

export default {
    props: {
        name: String,
        separation: {
            type: Number,
            default: 10, // px
        },

        slide: {
            type: Number,
            default: 0, // px
        },

        placement: {
            type: String,
            default: "bottom-start",
            required: false,
        },

        fixed: {
            type: Boolean,
            default: true,
            required: false,
        },

        tag: null,
    },

    setup() {
        const { listen } = useListenerManager()
        return { listen }
    },

    data() {
        return {
            show: false,
            idTimeout: null,
            uniqueId: 1,
        }
    },

    created() {
        this.mouseenter = this.mouseenter.bind(this)
        ;((this.mouseleave = this.mouseleave.bind(this)),
            (this.mouseleaveTooltip = this.mouseleaveTooltip.bind(this)))
    },

    mounted() {
        const ref = this.findDomReference(this.name)
        if (!ref) throw new Error(`Couldn't find reference: ${this.name}`)
        ref.addEventListener("mouseenter", this.mouseenter)
        ref.addEventListener("mouseleave", this.mouseleave)
        this.listen("scroll", () => {
            this.uniqueId = Math.floor(Math.random() * 1000)
            clearTimeout(this.idTimeout)
            this.show = false
        })
    },

    beforeUnmount() {
        this.cleanUp()
    },

    methods: {
        cleanUp() {
            this.$el.removeEventListener("mouseleave", this.mouseLeaveTooltip)
            try {
                const ref = this.findDomReference(this.name)

                ref && ref.removeEventListener("mouseenter", this.mouseenter)
                ref && ref.removeEventListener("mouseleave", this.mouseleave)
            } catch (e) {
                throw new Error(e)
            }
        },

        findDomReference(name) {
            return findDomReference(name, this)
        },

        mouseenter() {
            this.idTimeout = setTimeout(() => {
                this.show = true
            }, DELAY)
        },

        mouseleave(event) {
            const ref = this.findDomReference(this.name)

            if (inside(this.$el, event.clientX, event.clientY)) {
                ref && ref.removeEventListener("mouseleave", this.mouseleave)
                this.$el.addEventListener("mouseleave", this.mouseleaveTooltip)
                return
            }

            clearTimeout(this.idTimeout)
            this.show = false
        },

        mouseleaveTooltip() {
            const ref = this.findDomReference(this.name)
            clearTimeout(this.idTimeout)
            this.show = false
            this.$el.removeEventListener("mouseleave", this.mouseleaveTooltip)
            ref && ref.addEventListener("mouseleave", this.mouseleave)
        },
    },

    components: {
        PopUp,
    },
}
</script>
